import { SettingAccountUser } from "../../PrivatePages/Components/HomePage/PrivateHeader/setIcon";
import {
  ContainerIcon,
  DeleteAccountContainer,
  List,
  ListItem,
  ListItemText,
  TitlePage,
} from "./DeleteAccountStepsStyles.styled";

export const DeleteAccountSteps = () => {
  return (
    <>
      <DeleteAccountContainer>
        <TitlePage>Delete Account Steps</TitlePage>
        <List type="1">
          <ListItem>
            <ListItemText>Open your main account page</ListItemText>
          </ListItem>
          <ListItem>
            <div>
              <ContainerIcon>
                Click on the icon <SettingAccountUser />
              </ContainerIcon>
            </div>
          </ListItem>
          <ListItem>
            <ListItemText>Go to the Security page</ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              Scroll to the “Danger Zone” section at the bottom and click Delete
              Account
            </ListItemText>
          </ListItem>
        </List>
      </DeleteAccountContainer>
    </>
  );
};
